'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _zh_CN = require('rmc-date-picker/lib/locale/zh_CN');

var _zh_CN2 = _interopRequireDefault(_zh_CN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    okText: '确定',
    dismissText: '取消',
    extra: '请选择',
    DatePickerLocale: _zh_CN2['default']
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/date-picker/locale/zh_CN.js
// module id = 676
// module chunks = 0